import { useEffect, useState } from 'react'
import { Modal } from 'react-bootstrap'
import { AiOutlineUsergroupAdd } from 'react-icons/ai'
import { BsList } from 'react-icons/bs'
import { getEmployers } from '../../../API/Analytics/employers'
import { getEmployeeByTraining, setEmployeeTraining } from '../../../API/Employee/Training'
import Loading from '../../../Components/Loading/Loading'
import { addEmployeeTranslate } from '../../../i18n/translatedMessages'
import { useIntl } from 'react-intl'

const AddEmployee = ({ handleClose, show, course }) => {
	const language = useIntl()
	const company = JSON.parse(localStorage.getItem('user'))
	const [employees, setEmployees] = useState([])
	const [add, setAdd] = useState(false)
	const [listTraining, setListTraining] = useState([])
	const [listID, setListID] = useState([])
	const [loadingModal, setLoadingModal] = useState(true)
	const [selectedItems, setSelectedItems] = useState([])

	useEffect(() => {
		const fetchList = async () => {
			setLoadingModal(true)
			const listEmployee = await getEmployers(company.id)
			const employeeByTraining = await getEmployeeByTraining(course)
			setLoadingModal(false)
			setListTraining(employeeByTraining)
			setEmployees(
				listEmployee.map(employee => ({
					id: employee?.id,
					name: employee?.name,
					area: employee?.area?.profileArea,
					level: employee?.level?.PositionN,
					curse: employeeByTraining?.some(user => user.employerId === employee.id),
				}))
			)
		}

		fetchList()
	}, [show, add])

	const checkUser = (id, option) => employees.map(employee => (employee.id === id ? { ...employee, curse: option } : employee))

	const addEmployee = id => {
		if (!listTraining.some(employee => employee.employerId === id)) {
			setEmployees(checkUser(id, true))
			setListID(prev => [...prev, id])
		}
	}

	const saveEmployee = async () => {
		setLoadingModal(true)
		try {
			await setEmployeeTraining({
				employerList: listID,
				capacitationId: Number(course),
			})
			setAdd(false)
			setListID([])
			setSelectedItems([])
		} catch (error) {
			console.error('Erro :', error)
		} finally {
			setLoadingModal(false)
		}
	}

	const close = () => {
		handleClose(false)
		setEmployees([])
		setListID([])
		setSelectedItems([])
		setAdd(false)
	}

	const handleSelect = id => {
		addEmployee(id)
		setSelectedItems(prev => [...prev, id])
	}

	const handleDeselect = id => {
		setEmployees(checkUser(id, false))
		setSelectedItems(prev => prev.filter(item => item !== id))
		setListID(prev => (prev.includes(id) ? prev.filter(item => item !== id) : prev))
	}

	return (
		<Modal className='tw-text-gray-800' size='lg' show={show} onHide={close} centered>
			<Modal.Header className='tw-flex tw-justify-between tw-gap-4 tw-border-b tw-pb-3'>
				<div
					className={`tw-flex tw-items-center tw-gap-2 tw-py-1 tw-px-4 tw-rounded-full tw-text-base tw-cursor-pointer ${
						!add ? 'tw-bg-blue-400 tw-text-white  hover:tw-brightness-110' : 'tw-bg-blue-400 tw-text-white  hover:tw-brightness-110'
					}`}
					onClick={() => setAdd(false)}
				>
					{language.locale === 'ES' ? 'Colaboradores agregados' : 'Colaboradores adicionados'}
					<BsList size={20} />
				</div>

				<div
					className={`tw-flex tw-items-center tw-gap-2 tw-py-1 tw-px-4 tw-rounded-full tw-text-base tw-cursor-pointer  ${
						add ? 'tw-bg-blue-400 tw-text-white  hover:tw-brightness-110' : 'tw-bg-blue-400 tw-text-white  hover:tw-brightness-110'
					}`}
					onClick={() => setAdd(true)}
				>
					{language.locale === 'ES' ? 'Agregar colaboradores' : 'Adicionar colaboradores'}
					<AiOutlineUsergroupAdd size={20} />
				</div>
			</Modal.Header>

			<Modal.Body className='tw-relative tw-max-h-[500px] tw-overflow-y-auto tw-pb-24'>
				{!add ? (
					loadingModal ? (
						<div className='tw-w-full tw-h-full tw-bg-white tw-flex tw-justify-center tw-items-center'>
							<Loading />
						</div>
					) : (
						<div className='tw-list-none tw-p-0 tw-m-0'>
							{listTraining.length > 0 ? (
								[...listTraining]
									.sort((a, b) => a.capacitationToEmployer?.name?.localeCompare(b.capacitationToEmployer?.name))
									.map(employee => (
										<div key={employee.id} className='tw-px-2 tw-py-1 tw-border-b tw-cursor-default'>
											<div className='tw-w-full tw-text-left tw-p-2 tw-rounded tw-transition tw-bg-gray-100'>
												{employee?.capacitationToEmployer?.name}{' '}
												{employees
													?.filter(e => e.id === employee.employerId)
													.map(e => (
														<span key={e.id} className='tw-text-sm tw-text-gray-500 tw-ml-2'>
															{e.level && e.area ? `${e.level} - ${e.area}` : ''}
														</span>
													))}
											</div>
										</div>
									))
							) : (
								<div className='tw-bg-gray-100 tw-text-gray-400 tw-font-bold tw-rounded tw-p-2 tw-flex tw-justify-center tw-shadow-md tw-w-full'>
									{addEmployeeTranslate.nullEmployersRegister}
								</div>
							)}
						</div>
					)
				) : (
					<div className='tw-list-none tw-p-0 tw-m-0'>
						{[...employees]
							.sort((a, b) => a.name.localeCompare(b.name))
							.map(employee => (
								<div key={employee.id} className={`tw-px-2 tw-py-1 border-bottom tw-cursor-pointer ${employee.curse ? 'tw-opacity-50' : ''}`}>
									<div
										className={`tw-w-full tw-text-left tw-p-2 tw-rounded tw-transition hover:tw-bg-gray-200 ${
											employee.curse ? 'tw-opacity-50 ' : 'tw-cursor-pointer'
										} ${selectedItems.includes(employee.id) ? 'tw-bg-gray-200' : ''}`}
										onClick={() => {
											if (!employee.curse) {
												selectedItems.includes(employee.id) ? handleDeselect(employee.id) : handleSelect(employee.id)
											}
										}}
									>
										{employee?.name}{' '}
										<span className='tw-text-sm tw-text-gray-500 tw-ml-2'>
											{employee.level && employee.area ? `${employee.level} - ${employee.area}` : ''}
										</span>
									</div>
								</div>
							))}
					</div>
				)}
			</Modal.Body>

			<div className='tw-absolute tw-bottom-0 tw-left-0 tw-right-0 tw-bg-white tw-border-t tw-p-4 tw-flex tw-justify-end tw-z-10'>
				<div
					onClick={add ? saveEmployee : close}
					className='tw-bg-blue-400 tw-text-white tw-rounded-full tw-px-6 tw-py-2 tw-font-semibold hover:tw-brightness-110 tw-cursor-pointer '
				>
					{add ? addEmployeeTranslate.saveBtn : addEmployeeTranslate.closeBtn}
				</div>
			</div>
		</Modal>
	)
}

export default AddEmployee
